// @flow
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';

// Components
import DrawingComponent from './DrawingComponent';

// Actions
import {
  setSignature,
  setSelfCheckInSigned
} from 'store/reducers/selfCheckIn/actions';

export default compose(
  withRouter,
  injectIntl,
  connect(
    null,
    {
      setSignature,
      setSelfCheckInSigned
    }
  )
)(DrawingComponent);



// WEBPACK FOOTER //
// ./src/components/atoms/DrawingComponent/DrawingComponentContainer.js